module.exports = __webpack_public_path__ + "static/media/myZoneTicketingColor.6b30aa69.svg";